// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* stylelint-disable no-empty-source */\n/* stylelint-disable no-invalid-position-at-import-rule */\n/* stylelint-disable no-duplicate-at-import-rules */\n/* stylelint-disable scss/dollar-variable-empty-line-before */", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors-primary": "#38485b",
	"colors-success": "#28c76f",
	"colors-danger": "#ea5455",
	"colors-warning": "#ffba00",
	"colors-dark": "#1e1e1e",
	"colors-grey-dark": "#56595c",
	"colors-grey": "#b8c2cc",
	"colors-grey-light": "#dae1e7",
	"colors-white": "#fff",
	"colors-black": "#22292f",
	"colors-invisible": "rgba(0, 0, 0, 0)",
	"colors-benchmark": "#8d8c8c",
	"colors-benchmark-dark": "#5f5f5f",
	"colors-live": "#c7650a",
	"colors-content": "#626262",
	"misc-border-radius-px": "5px",
	"typography-font-family-sans-serif": "\"Montserrat\", helvetica, arial, sans-serif"
};
export default ___CSS_LOADER_EXPORT___;
